/**
 * 系统管理 用户管理
 */
<template>
  <div class="user-box">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>账号信息</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 
    <el-row>
      <el-col :span="16">

        <el-card class="box-card">
          <div slot="header" class="clearfix box-card-header">
            <span>基本信息</span>
           
          </div>
          <div class="text">
            <el-row>
              <el-col :span="8">
                <div>
                  <el-image style="width: 100px; height: 100px;border-radius: 50px;" src="https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg" :fit="fit"></el-image>
                </div>
                <div class="user-logo">
                  <el-button type="text">修改头像</el-button>
                </div>
              </el-col>
              <el-col :span="16">
                <el-descriptions title="" column="1" :colon="false" class="user-info">
                  <el-descriptions-item label="用户昵称">kooriookami <i class="el-icon-edit"></i> </el-descriptions-item>
                  <el-descriptions-item label="联系手机">18100000000 </el-descriptions-item>
                  <el-descriptions-item label="注册时间">2022年03月20日 21:14:19</el-descriptions-item>
                </el-descriptions>
              </el-col>
            </el-row>

          </div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card class="box-card" style="height: 100%">
          <div slot="header" class="clearfix box-card-header">
            <span>您的客户经理信息</span>
          </div>
          <div class="text">
            <el-descriptions title="" column="1" :colon="false" class="customermanager-info">
              <el-descriptions-item label="客户经理">kooriookami </el-descriptions-item>
              <el-descriptions-item label="联系方式">18100000000 </el-descriptions-item>
            </el-descriptions>
          </div>
        </el-card>
      </el-col>
    </el-row>
     -->
    <!-- 基本信息 -->
    <el-card class="box-card">
      <div slot="header" class="clearfix box-card-header">
        <span>基本信息</span>
        <!-- <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button> -->
      </div>
      <div class="text">
        <el-row>
          <el-col :span="8">
            <div>
              <!-- <el-image style="width: 100px; height: 100px;border-radius: 50px;" src="https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg" :fit="'fill'"></el-image> -->
              <el-upload
                class="avatar-uploader"
                action="#"
                :http-request="doUpload" 
                :show-file-list="false"
                :before-upload="beforeAvatarUpload">
                <img v-if="user.avatar" :src="user.avatar" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>
            <!-- <div class="user-logo">
              <el-button type="text">修改头像</el-button>
            </div> -->
          </el-col>
          <el-col :span="16">
            <el-descriptions title="" column="1" :colon="false" class="user-info">
              <el-descriptions-item label="用户名">
                <span v-show="usernameModifyShow">

                  {{user.username}}  <i class="el-icon-edit" @click="usernameModifyShow=!usernameModifyShow;username=user.username"></i>
                </span>
                <span v-show="!usernameModifyShow">
                  <el-input v-model="username" size="mini"></el-input>
                  <el-button type="primary" size="mini" @click="modifyName('username',username)">保存</el-button>
                  <el-button type="info" plain size="mini" @click="usernameModifyShow=!usernameModifyShow">取消</el-button>

                </span>
              </el-descriptions-item>
              <el-descriptions-item label="用户昵称">
                <span v-show="nameModifyShow">

                  {{user.nickname}} <i class="el-icon-edit" @click="nameModifyShow=!nameModifyShow;nickname=user.nickname"></i>
                </span>
                <span v-show="!nameModifyShow">
                  <el-input v-model="nickname" size="mini"></el-input>
                  <el-button type="primary" size="mini" @click="modifyName('nickname',nickname)">保存</el-button>
                  <el-button type="info" plain size="mini" @click="nameModifyShow=!nameModifyShow">取消</el-button>

                  <!-- <el-button type="primary" icon="el-icon-check" circle size="mini"></el-button>
                  <el-button type="info" icon="el-icon-close" circle size="mini"></el-button> -->
                </span>
              </el-descriptions-item>
              <el-descriptions-item label="联系手机">{{user.mobile?user.mobile:'未设置'}} </el-descriptions-item>
              <el-descriptions-item label="邮箱">{{user.email?user.email:'未设置'}} </el-descriptions-item>
              <el-descriptions-item label="注册时间">{{create_time}}</el-descriptions-item>
            </el-descriptions>
          </el-col>
        </el-row>

      </div>
    </el-card>

    <!-- 登录方式 -->
    <el-card class="box-card">
      <div slot="header" class="clearfix box-card-header">
        <span>登录方式</span>
        <!-- <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button> -->
      </div>
      <div class="text">
        <el-row>
          <el-col :span="3">
            <div class="content-title">密码</div>
          </el-col>
          <el-col :span="16">
            <div class="content-tips">建议您定期更换密码，设置一个包含字母，符号或数字中至少两项且长度超过6位的密码</div>
          </el-col>
          <el-col :span="5">

            <div class="content-operation">
              <i :class="[ 
                      user.hasPassword?'el-icon-circle-check el-button-success' : 'el-icon-warning-outline el-button-warning',
                      ]"
              ></i>
              <el-button type="text" :class="user.hasPassword?'el-button-success':'el-button-warning'">{{user.hasPassword?'已设置':'未设置'}}</el-button>
              <el-divider direction="vertical"></el-divider>
              <el-button type="text" @click="modify(0)">修改</el-button>
            </div>
          </el-col>
        </el-row>
        <p class="underline"></p>
        <el-row>
          <el-col :span="3">
            <div class="content-title">手机</div>
          </el-col>
          <el-col :span="16">
            <div class="content-tips">您已绑定了手机{{user.mobile}} [您的手机号可以直接用于登录、找回密码等]</div>
          </el-col>
          <el-col :span="5">

            <div class="content-operation">
              <i :class="[ 
                      user.mobile?'el-icon-circle-check el-button-success' : 'el-icon-warning-outline el-button-warning',
                      ]"></i>
              <el-button type="text" :class="user.mobile?'el-button-success':'el-button-warning'">{{user.mobile?'已设置':'未设置'}}</el-button>
              <el-divider direction="vertical"></el-divider>
              <el-button type="text" @click="modify(1)">修改</el-button>
            </div>
          </el-col>
        </el-row>
        <p class="underline"></p>
        <el-row>
          <el-col :span="3">
            <div class="content-title">邮箱</div>
          </el-col>
          <el-col :span="16">
            <div class="content-tips">邮箱绑定后可用来接收华万控制台发送的各类系统、营销、服务通知。</div>
          </el-col>
          <el-col :span="5">
            <div class="content-operation">
              <i :class="[ 
                      user.email?'el-icon-circle-check el-button-success' : 'el-icon-warning-outline el-button-warning',
                      ]"></i>
              <el-button type="text" :class="user.email?'el-button-success':'el-button-warning'">{{user.email?'已设置':'未设置'}}</el-button>
              <el-divider direction="vertical"></el-divider>
              <el-button type="text" @click="modify(2)">修改</el-button>
            </div>
          </el-col>
        </el-row>
        <p class="underline"></p>
        <el-row>
          <el-col :span="3">
            <div class="content-title">微信</div>
          </el-col>
          <el-col :span="16">
            <div class="content-tips">用于快速登录、接收重要通知、即时移动管理</div>
          </el-col>
          <el-col :span="5">
            <div class="content-operation">
              <i :class="[ 
                      user.bindWeiChat?'el-icon-circle-check el-button-success' : 'el-icon-warning-outline el-button-warning',
                      ]"></i>
              <el-button type="text" :class="user.bindWeiChat?'el-button-success':'el-button-warning'">{{user.bindWeiChat?'已设置':'未设置'}}</el-button>
              <el-divider direction="vertical"></el-divider>
              <el-button type="text" @click="modify(3)">修改</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-card>

    <el-dialog title="微信扫码" :visible.sync="centerDialogVisible" width="50%" center :close-on-click-moda="false"
    @close="closeScan">
      <div style="    display: flex;justify-content: center;padding-bottom: 20px;">
        <div style="width: 260px;  height: 260px;  border: 1px solid #c9c5c5; text-align: center;    display: flex;
    align-items: center;justify-content: center;">

          <div ref="qrCodeUrl"></div>

          <!-- 中间的logo，通过position:absolute;定位到中间 -->
          <img class="qrcode-logo" width="55" src="@/assets/img/scanlogo.png" alt="华万">

          <div class="qrcode_login_rl_bg" id="qrcode_login_timeout_tips"  v-show="isTimeout" >
            <div class="qrcode_login_rl_mask"></div>
            <div class="qrcode_login_rl_info">
              <i class="ww_commonImg ww_commonImg_Alert"></i>
              <div class="qrcode_login_rl_label"> 
                二维码已过期 
                <el-button type="text" @click="qrCodeGeneration">刷新</el-button>
              </div>
            </div>
          </div>


        </div>

      </div>

      <div class="bdwxsm">
        <!-- <p>使用微信扫一扫登录 <br> "华万控制台"</p> -->

      </div>
    </el-dialog>

  </div>
</template>

<script>
//导入插件
import moment from 'moment'
import QRCode from 'qrcodejs2'

//API
import {usermodify, scan, checkscan, user, uploadAvatar} from '../../api/userMG'


export default {
  data() {
    return {
      isTimeout: false, //二维码状态
      ticket: '',
      timer: null,
      nameModifyShow: true,
      usernameModifyShow: true,
      user: {},
      centerDialogVisible: false,
      nickname: '',
      username: '',
    }
  },
  computed: {//计算
      create_time() {
          return moment(this.user.createTime).format('yyyy年MM月DD日')
      },
  },
  // 注册组件
  components: {},

  /**
   * 数据发生改变
   */
  watch: {
   
  },

  /**
   * 创建完毕
   */
  created() {
    // this.user = this.$store.state.user
    // const userinfo = localStorage.getItem("userInfo");
    // this.user = JSON.parse(userinfo)
    // console.log(this.user)

    user('me').then(res=>{
        if(res.code==0){
          this.user = res.data
          // this.user.avatar = 'http://e.zoomok.com.cn/uploads/20221025/f82e23ef3f029d24ff6ff2df79eb29d6.jpg'
          this.$store.commit('login', this.user)
        }
    })
  },
  
  // 销毁前状态(里面是操作)
  beforeDestroy() {
    clearInterval(this.timer);
  },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    modifyName(prop,value) {
      let params = {}
      params[prop]  =value
      // if(prop==='nickname'){
      //     params = {  nickname: value }
      // }else if(prop==='username'){
      //     params = {  username: value }
      // }
      usermodify(params).then(res=>{
        if(res.code==0){
          this.$message({
            type: 'success',
            message: '保存成功'
          })
          if(prop==='nickname'){
            this.nameModifyShow = !this.nameModifyShow
          }else if(prop==='username'){
              this.usernameModifyShow = !this.usernameModifyShow
          }
          this.user[prop] = value
          this.$store.commit('login', this.user)
        }else{
          this.$message({
            type: 'error',
            message: res.message
          })
        }
      })
      
    },
    modify(num) {
      if (num === 0) {
        this.$router.push({ path: '/personal/password', query:{flag: this.user.hasPassword} })
      } else if (num === 1) {
        this.$router.push({ path: '/personal/mobilechange' })
      } else if (num === 2) {
        this.$router.push({ path: '/personal/emailchange' })
      } else if (num === 3) {
        this.centerDialogVisible = !this.centerDialogVisible
        this.qrCodeGeneration()
      }
    },
    // 二维码生成
    qrCodeGeneration() {
        this.isTimeout = false
        // 二维码弹框显示
        if(this.$refs.qrCodeUrl){
          this.$refs.qrCodeUrl.innerHTML = ""
        }
        // 生成二维码
        scan({action:'bind', "userId": this.user.id}).then(res=>{
          var qrcode = new QRCode(this.$refs.qrCodeUrl, {
                text: res.url, // 需要转换为二维码的内容
                width: 230,
                height: 230,
                // render: "canvas", // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
                colorDark: "#000000", //二维码颜色
                colorLight: "#ffffff", //二维码背景色
                correctLevel: QRCode.CorrectLevel.H, //容错率，L/M/H
          });
          
          this.ticket = res.ticket
          this.setTimer();//开启定时任务
          
        })
    },
    /**定时器*/
    setTimer() {
      this.timer = setInterval(() => {
        this.checkQrCode();
      }, 2000);
    },
    checkQrCode() {
      let that = this;
      checkscan({"ticket": this.ticket}).then(res=>{
        if(res==1){
          clearInterval(that.timer);//扫码成功后清空定时器
          that.$message.success('扫码成功')
          that.centerDialogVisible = false
          that.user.bindWeiChat  =true
          this.$store.commit('login', that.user)
        }else if(res==-1){
          clearInterval(that.timer);//扫码超时后清空定时器
					that.isTimeout = true;//出现刷新的遮罩
        }else if(res==1009){
          // clearInterval(that.timer);//扫码超时后清空定时器
          that.$message.warning('该微信已绑定其他账号')
        }
      })
    },
    doUpload(option){
        console.log(option)
        const file = option.file
        // 根据后台需求数据格式
        const form = new FormData();
        // 文件对象
        form.append("file", file);
        uploadAvatar(form).then(res=>{
          if(res.code==0){
            this.$message.success('更新成功')
            this.user.avatar = res.data
            this.$store.commit('login', this.user)
          }
        })
    },
    beforeAvatarUpload(file) {
      // const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 2;

      // if (!isJPG) {
      //   this.$message.error('上传头像图片只能是 JPG 格式!');
      // }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      // return isJPG && isLt2M;
      return isLt2M;
    },
    closeScan(){
      clearInterval(this.timer);//扫码超时后清空定时器
    }
  }
}
</script>

<style scoped>
.box-card-header {
  font-size: 14px;
  font-weight: 600;
}
.user-logo {
  text-align: center;
  width: 100px;
}
.user-info i {
  margin-left: 3px;
  color: #66b1ff;
}
.el-button-success {
  color: #67c23a;
}
.el-button-warning {
  color: #ebb563;
}
.underline {
  border-bottom: dashed 1px #d8d8d8;
}
.customermanager-info {
  font-size: 12px;
}
.wxewmImg {
  width: 250px;
  height: 250px;
}
.bdwxsm {
  text-align: center;
  font-size: 12px;
  font-weight: 400;
  margin-top: 20px;
  /*display: flex;
    justify-content: center;
    text-align: left;*/
}

.qrcode_login_rl_bg {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
}
.qrcode_login_rl_mask {
    width: 260px;
    height: 260px;
    position: absolute;
    top: 55px;
    left: 52%;
    margin-left: -143px;
    background: rgba(255, 255, 255, .9);
}
.qrcode_login_rl_info {
    position: absolute;
    top: 163px;
    width: 100%;
    text-align: center;
    z-index: 2;
    font-size: 14px;
}
</style>

<style >
.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: '';
}
.clearfix:after {
  clear: both;
}

.user-box .box-card {
  margin: 20px 20px;
}
.user-box .el-card__header {
  border-bottom: 1px solid #ebeef5;
}
.user-box .el-descriptions-item__label:not(.is-bordered-label) {
  margin-right: 70px;
}
.user-box .el-descriptions-item__container {
  margin-bottom: 10px;
}
.user-box .el-input {
  width: 140px;
}
.user-box .el-dialog__body {
  padding: 0;
}


.avatar-uploader .el-upload {
    border: 1px dashed #c5c1c1;
    border-radius: 50%;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
  }
  .avatar {
    width: 150px;
    height: 150px;
    display: block;
  }

  .user-box .el-descriptions-item__label {
    width: 70px;
    text-align: right;
  }

  
.qrcode-logo {
	position: absolute;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
	width: 55px;
}


</style>
 


// WEBPACK FOOTER //
// src/views/personal/user.vue